import { render, staticRenderFns } from "./Phone_whitelist_editor.vue?vue&type=template&id=2b7c687a"
import script from "./Phone_whitelist_editor.vue?vue&type=script&lang=js"
export * from "./Phone_whitelist_editor.vue?vue&type=script&lang=js"
import style0 from "./Phone_whitelist_editor.vue?vue&type=style&index=0&id=2b7c687a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports